import { showSnackbar } from '@lyearn-team/frontend-components/dist/showSnackbar/showSnackbar';
import cookie from './cookie';
import { blockUserInteraction } from './blockUserInteractionHelper';
import * as databaseLock from './lock';
import { clearAllIDBStores } from './LearningSpaceServices/IndexedDBHelper';

const addMasqueradeUserCompany = async (userId, userEmail, companyId, companySubDomain) => {
  if (!userId || userId.indexOf('@') !== -1) {
    showSnackbar({
      label: 'Please provide valid user Id',
      status: 'error'
    });
    return;
  }
  blockUserInteraction(true);
  await databaseLock.acquire();

  await clearAllIDBStores();
  const cookieValue = JSON.stringify({
    user_id: userId || '',
    email: userEmail || '',
    companyId: companyId || '',
    companySubDomain
  });
  cookie.set('masquerade_user', cookieValue, 1);
  window.location.reload();

  await databaseLock.unlock();
  blockUserInteraction(false);
};

const removeMasqueradeUserCompany = async () => {
  blockUserInteraction(true);
  await databaseLock.acquire();

  await clearAllIDBStores();
  cookie.delete('masquerade_user');
  window.location.reload();

  await databaseLock.unlock();
  blockUserInteraction(false);
};

window.__addMasqueradeUserToCookie = addMasqueradeUserCompany;
window.__removeMasqueradeUserFromCookie = removeMasqueradeUserCompany;

export { addMasqueradeUserCompany, removeMasqueradeUserCompany };
